<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <path d="M2 14.5H15" stroke="#E5E5E5" stroke-width="1.4" stroke-linecap="round"/>
  <path d="M3.5 14.5V3.5H7.5V14.5" stroke="#E5E5E5" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
  <rect x="4.3" y="5" width="2.4" height="7" rx="0.5" fill="#E5E5E5"/>
  <path d="M7.5 11H12.5V8.5" stroke="#E5E5E5" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
  <circle cx="12" cy="5.5" r="1.5" fill="#E5E5E5"/>
  <path d="M10 5.5L7.5 7.5" stroke="#E5E5E5" stroke-width="1.3" stroke-linecap="round"/>
</svg>
